import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PlayBlocksBlocksIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#7985a3' : this.getColor()
        return [
            <g transform="translate(0.985 0.75)">
                <g>
                    <path d="M12,27.429v9.143L20,40l8-3.429V27.429" transform="translate(-12 -24)" fill="none" stroke={ color } strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    <path d="M28,25.714l-8-3.429-8,3.429" transform="translate(-12 -22.286)" fill="none" stroke={ color } strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                </g>
                <g transform="translate(0 3.429)">
                    <line x2="8" y2="3.429" fill="none" stroke={ color } strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    <path d="M32,27.429l-8,3.429V40" transform="translate(-16 -27.429)" fill="none" stroke={ color } strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                </g>
            </g>
        ]
    }
    getViewBox = () => '0 0 17.97 17.5'
}
